import DatePicker from 'rsuite/DatePicker'
import styled from "styled-components";

export const StyledDatePicker = styled(DatePicker)`
    width: 100%;
`